// If any of these variables are modified, remember to change them in oneObject.js as well
const ONE_META_NAME = 'one-data';
const ONE_STATIC_FILE_PREFIX_ATTRIBUTE = 'data-one-static-file-prefix';
const oneMeta = document.head.querySelector(`meta[name=${ONE_META_NAME}]`);

// "Magic" variable that allows import paths for resources in JS bundles (e.g. images, CSS, etc.) to be resolved based on the prefix served
// at runtime by the API router in the HTML file.
// See https://github.com/webpack/webpack/issues/2776#issuecomment-233208623

__webpack_public_path__ =
  oneMeta?.getAttribute(ONE_STATIC_FILE_PREFIX_ATTRIBUTE) ?? '';

export {};
